module.exports = __webpack_public_path__ + "static/img/media_04.d790cfa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/media_04.png
// module id = aHXW
// module chunks = 0